<template>
  <input
    :value="value"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    :required="required"
    type="text"
    @input="onInput"
    @blur="$emit('blur')"
  >
</template>
<script>
export default {
  name: 'InputTemplate',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
  },
};
</script>
